import { useApplicationParameters } from "src/api/client-api/appParams";

export const useIsOpenFoodFactsSearchEnabled = (): boolean => {
    const { isFeatureActivated } = useApplicationParameters();

    return isFeatureActivated("FS-open-food-facts-search");
};
